class CollectionGrid extends HTMLElement {
  #controller = null;

  render(params = new URLSearchParams()) {
    this.#controller?.abort();

    const controller = new AbortController();

    this.#controller = controller;
    this.classList.add("state--loading");

    const url = new URL(window.location.pathname, window.location.origin);

    url.searchParams.set("section_id", this.id);

    for (const [key, value] of params.entries()) {
      if (key === "section_id" || key === "sections") {
        continue;
      }

      url.searchParams.append(key, value);
    }

    return fetch(url.href, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Collection request failed with status ${response.status}`);
        }

        return response.text();
      })
      .then((html) => this.apply(html))
      .catch((error) => {
        if (error.name === "AbortError") {
          return;
        }

        console.error(error);
      })
      .finally(() => {
        if (this.#controller !== controller) {
          return;
        }

        this.#controller = null;
        this.classList.remove("state--loading");
      });
  }

  apply(html) {
    const next = new DOMParser().parseFromString(html, "text/html").getElementById(this.id);

    if (!next) {
      throw new Error(`Collection response is missing #${this.id}`);
    }

    this.querySelectorAll("[data-collection-replace]").forEach((region) => {
      const replacement = next.querySelector(
        `[data-collection-replace="${region.dataset.collectionReplace}"]`
      );

      if (replacement) {
        region.replaceWith(replacement);
      }
    });

    this.dispatchEvent(new CustomEvent("collectiongrid:rendered", { bubbles: true }));
  }
}

customElements.define("collection-grid", CollectionGrid);


class ComponentCollectionFilters extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.defineElements({ form: ":scope > form" });

    this.addDirectEvent("change", this, this.change);
    this.addDirectEvent("popstate", window, this.restore);
  }

  get grid() {
    return this.closest("collection-grid") || document.querySelector("collection-grid");
  }

  change(event) {
    if (event.target.type !== "radio") {
      return;
    }

    const params = new URLSearchParams(window.location.search);

    Array.from(params.keys()).forEach((key) => {
      if (key.startsWith("filter.") || key === "page") {
        params.delete(key);
      }
    });

    this.elements.form.querySelectorAll("input[type='radio']:checked").forEach((input) => {
      if (input.value) {
        params.append(input.name, input.value);
      }
    });

    const search = params.toString();

    history.pushState(
      { search: search },
      "",
      search ? `${window.location.pathname}?${search}` : window.location.pathname
    );

    this.grid?.render(params);
  }

  restore(event) {
    this.grid?.render(new URLSearchParams(event.state?.search ?? window.location.search));
  }
}

customElements.define("component-collection-filters", ComponentCollectionFilters);
